export default __webpack_public_path__ + "img/a824d5b790b7d5a39646bf89d24245b8.png";